
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ServicesMasterGrid extends Serenity.EntityGrid<ServicesMasterRow, any> {
        protected getColumnsKey() { return 'OMS.ServicesMaster'; }
        protected getDialogType() { return ServicesMasterDialog; }
        protected getIdProperty() { return ServicesMasterRow.idProperty; }
        protected getInsertPermission() { return ServicesMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return ServicesMasterRow.localTextPrefix; }
        protected getService() { return ServicesMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}